// @ts-nocheck
import * as React from "react";

const BookmarkFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M6 21a1 1 0 01-1-1V5.33A2.28 2.28 0 017.2 3h9.6A2.28 2.28 0 0119 5.33V20a1 1 0 01-1.5.86l-5.67-3.21-5.33 3.2A1 1 0 016 21z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BookmarkFill);
